export const AlgorithmsPath = '/algorithms';
export const AlgorithmsUrls = {
  page: AlgorithmsPath,
};
